function formatDate(date) {
  var year = date.getUTCFullYear();
  var month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
  var day = ('0' + date.getUTCDate()).slice(-2);
  var hours = ('0' + date.getUTCHours()).slice(-2);
  var minutes = ('0' + date.getUTCMinutes()).slice(-2);
  var seconds = ('0' + date.getUTCSeconds()).slice(-2);
  return year + month + day + 'T' + hours + minutes + seconds + 'Z';
}

const formatDates = (dates) => {
  const start = new Date(dates?.[0]?.flights?.[0]?.start);
  const end = new Date(dates?.[0]?.flights?.[0]?.end);

  return {
    start: formatDate(start),
    end: formatDate(end),
  };
};
const downloadIcsFile = ({ title, flights, id, description = '' }) => {
  const dates = formatDates(flights);
  description = `${description} \n ${window.location.protocol}//${window.location.hostname}/player/${id}
      `;
  var icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//My Calendar//EN
BEGIN:VEVENT
DTSTART:${dates.start}
DTEND:${dates.end}
SUMMARY:${title}
DESCRIPTION:${description}
END:VEVENT
END:VCALENDAR`;

  var blob = new Blob([icsContent], { type: 'text/calendar' });
  var url = URL.createObjectURL(blob);

  var downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = title.replace(/\s+/g, '-') + '.ics';

  downloadLink.click();

  URL.revokeObjectURL(url);
};

export const calendars = [
  {
    title: 'Google Calendar',
    url: 'https://www.google.com/calendar/render?action=TEMPLATE&text=${encodedTitle}&dates=${encodedStartDate}/${encodedEndDate}&details=${encodedDescription}',
  },
  {
    title: 'Outlook Calendar',
    fn: downloadIcsFile,
  },
  {
    title: 'Apple Calendar',
    fn: downloadIcsFile,
  },
];

export const getUrlCalendar = (
  { title, flights, id, description = '' },
  url
) => {
  const dates = formatDates(flights);

  description = `
${description}

${window.location.protocol}//${window.location.hostname}/player/${id}
    `;

  var encodedTitle = encodeURIComponent(title);
  var encodedDescription = encodeURIComponent(description);
  var encodedStartDate = encodeURIComponent(dates.start);
  var encodedEndDate = encodeURIComponent(dates.end);

  const uri = url
    .replace('${encodedTitle}', encodedTitle)
    .replace('${encodedDescription}', encodedDescription)
    .replace('${encodedStartDate}', encodedStartDate)
    .replace('${encodedEndDate}', encodedEndDate);

  return uri;
};
